import { useEffect, useState, Suspense, lazy } from "react";

const Inner = lazy(() => import("./Scene3DInner").catch(() => ({ default: () => null })));

export default function Scene3D() {
    const [src, setSrc] = useState(null);
    useEffect(() => {
        setSrc(document.getElementById("hero"));
    }, []);
    return (
        <div className="pointer-events-none absolute inset-0 opacity-90" aria-hidden="true" data-testid="scene-3d">
            <Suspense fallback={null}>{src ? <Inner eventSource={src} /> : null}</Suspense>
        </div>
    );
}
